class NavigationDesktop extends HTMLElement {
  constructor() {
    super();
  }

  updateLink(handle) {
    this.activeHandle = handle.dataset.handle;

    this.links.forEach((link) => {
      link.classList.toggle(
        "active",
        link.dataset.handle === this.activeHandle
      );
    });

    this.products.forEach((product) => {
      product.classList.toggle(
        "active",
        product.dataset.handle === this.activeHandle
      );
    });

    this.blogs.forEach((banner) => {
      banner.classList.toggle(
        "active",
        banner.dataset.handle === this.activeHandle
      );
    });
  }

  connectedCallback() {
    this.links = this.querySelectorAll(".header__shop-item--list > ul > li");
    this.products = this.querySelectorAll(
      ".header__shop-item--products .header__shop-item__products"
    );
    this.blogs = this.querySelectorAll(
      ".header__shop-item--blog .header__shop-item__blog"
    );

    this.activeHandle = this.links[0]?.dataset.handle || "default";

    this.menuItem = document.querySelector(
      ".header__navigation-link.js-shop-hover > a"
    );
    this.megamenu = this.querySelector(".js-header__shop");

    // this.menuItem.addEventListener("keydown", function (evt) {
    //   if (evt.code === "Enter") {
    //     evt.preventDefault();
    //     evt.stopPropagation();
    //     console.log("dddddddddd");

    //     return;
    //   }
    // });

    this.addEventListener("keydown", (evt) => {
      // const first = evt.target.closest("[data-first-item]");
      // const last = evt.target.closest("[data-last-item]");
      // // console.log("evt.key", evt.key);
      // // // if (evt.key === "Enter") {
      // // //   evt.preventDefault();
      // // //   evt.stopPropagation();
      // // //   evt.target.preventDefault();
      // // //   return;
      // // // }
      // if (evt.key === "Tab") {
      //   if (evt.shiftKey && first) {
      //     evt.preventDefault();
      //     const last = this.querySelector(
      //       `.header__shop-item__blog.active [data-last-item]`
      //     );
      //     last.focus();
      //     return;
      //   }
      //   if (!evt.shiftKey && last) {
      //     evt.preventDefault();
      //     const first = this.querySelector(`[data-first-item]`);
      //     first.focus();
      //     return;
      //   }
      // }
    });

    this.addEventListener("mouseover", (evt) => {
      const handle = evt.target.closest("[data-handle]");

      if (
        !handle ||
        handle.dataset.handle === this.activeHandle ||
        evt.target.tagName !== "SPAN"
      )
        return;

      this.updateLink(handle);
    });

    this.addEventListener("click", (evt) => {
      const url = evt.target.closest("[data-url]");

      if (evt.target.tagName !== "SPAN" || !url || !url.dataset.url) return;

      window.location.assign(url.dataset.url);
    });

    this.addEventListener("keydown", (evt) => {
      const handle = evt.target.closest("[data-handle]");
      // const form = evt.target.closest("form[action='/cart/add']");
      // const blog = evt.target.closest(".header__shop-item__blog.active");

      const first = evt.target.closest("[data-first-item]");
      const last = evt.target.closest("[data-last-item]");

      if (evt.key === "Enter") {
        // if (form || blog) {
        //   if (evt.target.tagName === "A" || evt.target.tagName === "BUTTON") {
        //     evt.target.click();
        //     console.log("evt.target.tagName");
        //     return;
        //   }

        //   if (evt.target.tagName === "A") {
        //     window.location = evt.target.href;
        //     return;
        //   }

        //   if (evt.target.tagName === "BUTTON") {
        //     evt.target.click();
        //     return;
        //   }
        // }

        if (!handle || handle.dataset.handle === this.activeHandle) {
          evt.target.click();
          return;
        }

        this.updateLink(handle);
        return;
      }

      // console.log("evt.key", evt.key);

      // // if (evt.key === "Enter") {
      // //   evt.preventDefault();
      // //   evt.stopPropagation();
      // //   evt.target.preventDefault();
      // //   return;
      // // }

      if (evt.key === "Tab") {
        if (evt.shiftKey && first) {
          evt.preventDefault();
          const last = this.querySelector(
            `.header__shop-item__blog.active [data-last-item]`
          );

          last.focus();
          return;
        }

        if (!evt.shiftKey && last) {
          evt.preventDefault();
          const first = this.querySelector(`[data-first-item]`);

          first.focus();
          return;
        }
      }
    });
  }
}

customElements.define("navigation-desktop", NavigationDesktop);
